import React from "react";
import { GenderList } from "../../../constants/common";
import Popover from "../Popover/Popover";
import "./GenderIcon.css";

interface GenderIconProps {
  gender: number;
}

// 渲染性别图标
const RenderGenderIcon: React.FC<GenderIconProps> = ({ gender }) => {
  // 男性
  if (gender === 0) {
    return (
      <Popover position="right" content={GenderList[gender]}>
        <svg
          className="gender-icon gender-male"
          viewBox="0 0 24 24"
          width="16"
          height="16"
        >
          <circle
            cx="10"
            cy="10"
            r="7"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
          />
          <line
            x1="15"
            y1="15"
            x2="20"
            y2="20"
            stroke="currentColor"
            strokeWidth="2"
          />
        </svg>
      </Popover>
    );
  }

  // 女性
  if (gender === 1) {
    return (
      <Popover position="right" content={GenderList[gender]}>
        <svg
          className="gender-icon gender-female"
          viewBox="0 0 24 24"
          width="16"
          height="16"
        >
          <circle
            cx="12"
            cy="10"
            r="7"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
          />
          <line
            x1="12"
            y1="17"
            x2="12"
            y2="22"
            stroke="currentColor"
            strokeWidth="2"
          />
          <line
            x1="9"
            y1="20"
            x2="15"
            y2="20"
            stroke="currentColor"
            strokeWidth="2"
          />
        </svg>
      </Popover>
    );
  }
  // 中性
  return (
    <Popover position="right" content={GenderList[gender]}>
      <svg
        className="gender-icon gender-neutral"
        viewBox="0 0 24 24"
        width="16"
        height="16"
      >
        <circle
          cx="12"
          cy="8"
          r="6"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
        />
        <path
          d="M12,14 L12,22 M8,18 L16,18"
          stroke="currentColor"
          strokeWidth="2"
        />
      </svg>
    </Popover>
  );
};

export default RenderGenderIcon;
